<template>
      <q-dialog ref="modal"  v-model="modal">
        <q-card class="card">
          <q-toolbar class="bg-primary">
            <q-toolbar-title><span class="text-body1 text-white">Fotos</span></q-toolbar-title>
            <q-btn flat round dense color="white" icon="close" v-close-popup />
          </q-toolbar>
  
          <q-card-section class="no-margin q-pa-xs">
              <q-card class="shadow-2 q-pa-xs">
                  <q-carousel
                    animated
                    v-model="slide"
                    arrows
                    navigation
                    control-color="primary"
                    infinite
                    height="430px"
                  >
                    <q-carousel-slide v-for="foto in arrayFotos.fotos" :key="foto.seq_img" :name="foto.seq_img" class="no-margin no-padding" >
                        <q-img :alt="foto.seq_img" v-if="!errorImg" :src="foto.url_img" @error="errorImg = !errorImg"/>
                        <q-img  v-else src="../assets/no-image.png"/>
                    </q-carousel-slide>
                </q-carousel>
            </q-card>
          </q-card-section>
        </q-card>
      </q-dialog>
  </template>
  <script>
  import { ref, reactive } from 'vue'
  
  export default {
    name: "QModalVisualizadorFotos",
    setup() {
        const arrayFotos = reactive({
          fotos: []
        })
        const slide = ref('1')
        const errorImg = ref(false)

        const fotosModal = (fotos) => {
          arrayFotos.fotos = fotos
        }
      return {
        arrayFotos,
        slide,
        errorImg,
        fotosModal
      }
    },
    methods: {
      show(fotos) {
        this.fotosModal(fotos)
        this.$refs.modal.show()
      },
      hide() {
        this.$refs.modal.hide()
      },

      $_showLoading(options) {
        this.$q.loading.show(options)
      },
  
      $_hideLoading() {
        this.$q.loading.hide()
      }
    },
  }
  </script>
<style lang="scss" scoped>
    .card {
        width: 100%;
        max-width: 500px;
        max-height: 500px;
    }
</style>